import { StrictEqualityComparer } from "../../shared/index.js";
import { BasicEnumerable } from "../BasicEnumerable.js";
export const distinct = (source, comparer = StrictEqualityComparer) => {
    function* iterator() {
        const distinctElements = [];
        for (const item of source) {
            const foundItem = distinctElements.find((x) => comparer(x, item));
            if (!foundItem) {
                distinctElements.push(item);
                yield item;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
